import { useQuery } from '@tanstack/react-query';

import { TmProduct } from '@/tscapi/model/product';
import http from '@/tscapi/service/httpservice';
import { Cookie } from '@/tscapi/utils/cookie';

import { getBaseUrl } from '@/tscapi/utils/utils';

export const useDonation = () => {
    const cookie: Cookie = new Cookie();
    const fetchDonation = async () => {
        const headers = {
            'Content-Type': 'application/json',
            currentdatetime: cookie.CurrentDate,
        };
        const base = getBaseUrl() + '/product/v1/';
        const lang = cookie.Language.substring(0, 2) || 'en';
        try {
            const response = await http.get(`${base}${lang}/products/donation`, {
                headers: headers,
            });
            return response.data as TmProduct[];
        } catch (e) {
            console.log('Error getting donation data');
            throw new Error('Error getting Donation data');
        }
    };

    return useQuery({
        queryKey: ['donation'],
        queryFn: fetchDonation,
        useErrorBoundary: true,
        retry: false,
        staleTime: 1000 * 60 * 5, //stale time 5 minutes
    });
};
